export { default as CloseIcon } from './close.svg'
export { default as ListIcon } from './list.svg'
export { default as WhatsAppGreen } from './whatsapp-green.svg'
export { default as DarkListIcon } from './dark-list-icon.svg'
export { default as StarIcon } from './star.svg'
export { default as ArrowRightIcon } from './arrow-right.svg'
export { default as ArrowLeftIcon } from './arrow-left.svg'
export { default as TimelineArrowRightUnpaintedIcon } from './timeline-arrow-right-unpainted.svg'
export { default as TimelineArrowRightPaintedIcon } from './timeline-arrow-right-painted.svg'
export { default as TimelineArrowLeftIcon } from './timeline-arrow-left.svg'
export { default as ChevronHorizontal } from './chevron-horizontal.svg'
export { default as Chevron } from './chevron.svg'
export { default as BlueChevron } from './blue-chevron.svg'
export { default as CloseIconBlack } from './close-black.svg'
export { default as GlobeIcon } from './globe.svg'
export { default as SearchIcon } from './search.svg'
export { default as WhiteGlobe } from './white-globe.svg'
export { default as BrIcon } from './br-icon.svg'
export { default as EnIcon } from './en-icon.svg'
export { default as FacebookIconBlack } from './facebook_icon_black.svg'
export { default as FacebookIconWhite } from './facebook_icon.svg'
export { default as InstagramIconBlack } from './instagram_icon_black.svg'
export { default as InstagramIconWhite } from './instagram_icon.svg'
export { default as WhatsAppIconBlack } from './whatsapp_icon_black.svg'
export { default as WhatsAppIconWhite } from './whatsapp_icon.svg'
export { default as LinkedinIconBlack } from './linkedin_icon_black.svg'
export { default as LinkedinIconWhite } from './linkedin_icon.svg'
export { default as AdaptedProcessesIcon } from './adapted-processes.svg'
export { default as HandGearIcon } from './hand-gear.svg'
export { default as MagnifierPeopleIcon } from './magnifier-people.svg'
export { default as PeopleStarIcon } from './people-star.svg'
